import { render, staticRenderFns } from "./FilaAtendimento.vue?vue&type=template&id=a00b8d3c&"
import script from "./FilaAtendimento.vue?vue&type=script&lang=js&"
export * from "./FilaAtendimento.vue?vue&type=script&lang=js&"
import style0 from "./FilaAtendimento.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports